<div class="icd-panel" *ngIf="row">
  <section class="icd-card">
    <div class="icd-card__header">
      <span class="icd-card__title" [title]="row.investmentDescription"><mat-icon>business</mat-icon> {{ row.investmentDescription || 'Inversión en empresas' }}</span>
      <app-status-pill [label]="paymentLabel" [variant]="paymentVariant"></app-status-pill>
    </div>

    <div class="icd-progress">
      <div class="icd-progress__bar">
        <div class="icd-progress__fill" [style.width.%]="row.percent"></div>
      </div>
      <div class="icd-progress__legend">
        <span>Pagado <strong>{{ row.paidAmount | number:'1.2-2' }} €</strong></span>
        <span>Pendiente <strong>{{ row.pendingAmount | number:'1.2-2' }} €</strong></span>
        <span>Inversión <strong>{{ row.investmentValue | number:'1.2-2' }} €</strong></span>
      </div>
    </div>

    <div class="icd-kpis">
      <div class="icd-kpi">
        <span class="icd-kpi__label">Participaciones</span>
        <span class="icd-kpi__value">{{ row.numberOfUnitsOrSharesInvested ? (row.numberOfUnitsOrSharesInvested | number:'1.0-2') : '—' }}</span>
      </div>
      <div class="icd-kpi">
        <span class="icd-kpi__label">Rentabilidad / interés</span>
        <span class="icd-kpi__value">{{ row.percentageOfProfitabilityOrInterest ? (row.percentageOfProfitabilityOrInterest | number:'1.2-2') + ' %' : '—' }}</span>
      </div>
      <div class="icd-kpi">
        <span class="icd-kpi__label">Plazo</span>
        <span class="icd-kpi__value">{{ row.termInMonths ? row.termInMonths + ' meses' : '—' }}</span>
      </div>
      <div class="icd-kpi icd-kpi--accent">
        <span class="icd-kpi__label">Valor neto contable</span>
        <span class="icd-kpi__value">{{ (row.netBookValue || 0) | number:'1.2-2' }} €</span>
      </div>
      <div class="icd-kpi">
        <span class="icd-kpi__label">Último balance</span>
        <span class="icd-kpi__value">{{ row.lastBalanceSheetDate ? (row.lastBalanceSheetDate | date:'dd/MM/yyyy') : '—' }}</span>
      </div>
      <div class="icd-kpi">
        <span class="icd-kpi__label">Genera rendimientos</span>
        <span class="icd-kpi__value">{{ row.generatesReturns ? 'Sí' : 'No' }}</span>
      </div>
    </div>

    <div class="icd-lines">
      <div class="icd-line">
        <span class="icd-line__label">Cuenta contable</span>
        <span class="icd-line__value" [title]="accountLabel">{{ accountLabel }}</span>
      </div>
      <div class="icd-line">
        <span class="icd-line__label">Fecha de la inversión</span>
        <span class="icd-line__value">{{ row.investmentDate ? (row.investmentDate | date:'dd/MM/yyyy') : '—' }}</span>
      </div>
      <div class="icd-line">
        <span class="icd-line__label">Documento adjunto</span>
        <span class="icd-line__value">
          <button *ngIf="hasFile" type="button" class="icd-link" (click)="download.emit()">
            <mat-icon>{{ row.isPdf ? 'attachment' : 'image' }}</mat-icon> {{ row.isPdf ? 'Descargar PDF' : 'Descargar imagen' }}
          </button>
          <ng-container *ngIf="!hasFile">—</ng-container>
        </span>
      </div>
    </div>

    <div class="icd-actions">
      <button mat-stroked-button class="cf-btn cf-btn--primary" (click)="edit.emit()">
        <mat-icon>edit</mat-icon> Editar inversión
      </button>
    </div>
  </section>

  <section class="icd-card">
    <div class="icd-card__header">
      <span class="icd-card__title"><mat-icon>date_range</mat-icon> Operaciones del ejercicio {{ year }}</span>
    </div>

    <app-loading-state *ngIf="loading" [compact]="true" message="Cargando pagos…"></app-loading-state>

    <div class="icd-empty icd-empty--error" *ngIf="!loading && error">
      <mat-icon>error</mat-icon>
      <span>No se pudieron cargar los pagos de la inversión.</span>
      <button mat-stroked-button class="cf-btn" (click)="retry()">
        <mat-icon>refresh</mat-icon> Reintentar
      </button>
    </div>

    <div class="icd-block" *ngIf="!loading && !error">
      <div class="icd-block__header">
        <span class="icd-block__title"><mat-icon>payment</mat-icon> Pagos</span>
        <span class="icd-block__side">
          <span class="icd-block__summary" *ngIf="yearCount > 0">
            {{ yearCount }} · <strong>{{ yearTotal | number:'1.2-2' }} €</strong>
          </span>
          <button mat-stroked-button type="button" class="cf-btn cf-btn--primary icd-add" (click)="add()">
            <mat-icon>add</mat-icon> Añadir
          </button>
        </span>
      </div>

      <div class="icd-moves" *ngIf="lines.length">
        <div class="icd-move" *ngFor="let line of lines; trackBy: trackByUid">
          <span class="icd-move__date">{{ line.date | date:'dd/MM/yyyy' }}</span>
          <span class="icd-move__info">
            <span class="icd-move__concept" [title]="line.concept">{{ line.concept }}</span>
            <span class="icd-move__meta" *ngIf="line.meta" [title]="line.meta">{{ line.meta }}</span>
          </span>
          <span class="icd-move__amount">{{ line.amount | number:'1.2-2' }} €</span>
          <span class="icd-move__actions">
            <button type="button" class="icd-icon-btn" (click)="editLine(line)" title="Editar" aria-label="Editar pago">
              <mat-icon>edit</mat-icon>
            </button>
            <button type="button" class="icd-icon-btn icd-icon-btn--danger" (click)="deleteLine(line)" title="Eliminar" aria-label="Eliminar pago">
              <mat-icon>delete</mat-icon>
            </button>
          </span>
        </div>
        <button type="button" class="icd-more" *ngIf="yearCount > maxLines" (click)="manage()">
          Ver los {{ yearCount }} pagos <mat-icon>chevron_right</mat-icon>
        </button>
      </div>

      <div class="icd-block__empty" *ngIf="!lines.length">
        Sin pagos en el ejercicio<ng-container *ngIf="depositsCount > 0"> · {{ depositsCount }} en otros ejercicios</ng-container>
      </div>

      <div class="icd-foot" *ngIf="depositsCount > 0">
        <span>Total pagado (todos los ejercicios) <strong>{{ row.paidAmount | number:'1.2-2' }} €</strong></span>
        <span *ngIf="commissionsTotal">Comisiones <strong>{{ commissionsTotal | number:'1.2-2' }} €</strong></span>
        <button type="button" class="icd-more" *ngIf="yearCount <= maxLines && depositsCount > yearCount" (click)="manage()">
          Ver todos los pagos <mat-icon>chevron_right</mat-icon>
        </button>
      </div>
    </div>
  </section>
</div>
